export const staffI18n = {
  en: {
    staffForInstitution: 'Staff for {institution} institution',
    addUser: 'Add user',
    filter: 'Filter',
    byInstitution: 'Institution',
    send: 'Send',
    confirmRemoveUser: 'Are you sure you want to remove the user {userName} from the current institution?',
    confirmRemoveUserTeacher: ' Please note that this teacher may be assigned to multiple classes, shared subjects, or templates. Deleting this teacher will remove their access to all associated classes and content. Do you wish to continue?',
    clear: 'Clear',
    inviteSelected: 'Invite Selected',
    inviteUsers: 'Enable to invite Eduac users to the current institution.',
    inviteUser: 'Invite User to organization',
    removeUser: 'Remove user from organization',
    selectRoleForInvite: 'Select a role for the user(s) to invite.',
    headers: {
      role: 'Role',
      status: 'Status',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      seeClasses: 'Current Classes',
      seeSubjects: 'Shared Subjects',
      seeTemplates: 'Shared Templates'
    },
    status: {
      approved: 'Approved',
      pending: 'Pending',
      denied: 'Denied',
      student: 'Student',
      teacher: 'Teacher',
      sa: 'School Admin',
      sda: 'School District Admin',
      author: 'Author',
    },
    info: {
      addStaffDisclamer: 'An invitation will be sent to the email entered below.',
      personBelongs: '{userName} already belongs to the current institution.',
      personBelongsOtherOrg: '{userName} already belongs to another institution.',
      userNeedsApproval: 'The user {userName} needs to be approved by the admin user before you can invite them to the institution.',
      actionNotPermited: 'Action not permitted',
      allUsersSameRole: 'All selected users must have the same Role and have Status: APPROVED (By admin user) to execute the bulk invite option.'
    },
    success: {
      userInvited: 'The invitation was sent successfully',
      userRemoved: 'The user was removed successfully from the current institution.',
      userAdded: 'The user was added successfully to the current institution.'
    },
    errors: {
      userNoInvited: 'There was an error sending the invitation, try again later.',
      userNoRemoved: 'The user could not be removed from the institution.',
      userNoAdded: 'The user could not be added to the institution.'
    }
  },
  es: {
    staffForInstitution: 'Personal para la institución {institution}',
    addUser: 'Agregar usuario',
    filter: 'Filtrar',
    byInstitution: 'Institución',
    send: 'Enviar',
    confirmRemoveUser: '¿Está seguro de que desea eliminar al usuario {userName} de la institución actual?',
    confirmRemoveUserTeacher: ' Tenga en cuenta que este profesor puede estar asignado a múltiples clases, tener asignaturas o plantillas compartidas. Al eliminarlo, se revocará su acceso a dichas clases y contenidos. ¿Desea continuar?',
    clear: 'Limpiar',
    inviteSelected: 'Invitar Selección',
    inviteUsers: 'Habilite para invitar usuarios de Eduac a la institución actual.',
    inviteUser: 'Invitar usuario a la organización',
    removeUser: 'Remover usuario de la organización',
    selectRoleForInvite: 'Seleccione un rol para el usuario(s) a invitar',
    headers: {
      role: 'Rol',
      status: 'Estado',
      firstName: 'Nombre',
      lastName: 'Apellidos',
      email: 'Correo electrónico',
      seeClasses: 'Clases actuales',
      seeSubjects: 'Asignaturas compartidas',
      seeTemplates: 'Plantillas compartidas'
    },
    info: {
      addStaffDisclamer: 'Se enviará una invitación al correo electrónico que ingrese.',
      personBelongs: '{userName} ya pertenece a la institución actual.',
      personBelongsOtherOrg: '{userName} ya pertenece a otra institución.',
      userNeedsApproval: 'El usuario {userName}, debe ser aprobado por el administrador para poder ser invitado a una institución.',
      actionNotPermited: 'Acción no permitida',
      allUsersSameRole: 'Todos los usuarios seleccionados deben tener el mismo Rol y tener un Estado: Aprobado (Por el administrador) para poder ejecutar la invitación en bloque.'
    },
    status: {
      approved: 'Aprobado',
      pending: 'Pendiente',
      denied: 'Denegado',
      student: 'Estudiante',
      teacher: 'Profesor',
      sa: 'Admin de escuela',
      sda: 'Admin de Distrito Escolar',
      author: 'Autor',
    },
    success: {
      userInvited: 'La invitación fue enviada con éxito.',
      userRemoved: 'El usuario fue eliminado de la institución con éxito.',
      userAdded: 'El usuario fue agregado a la institución con éxito.'
    },
    errors: {
      userNoInvited: 'Hubo un problema enviando la invitación, intente de nuevo mas tarde.',
      userNoRemoved: 'El usuario no pudo ser eliminado con éxito.',
      userNoAdded: 'El usuario no pudo ser agregado con éxito.'
    }
  }
}